import axios from '../environments/environments';

/**
 * Service to get assignment
 * 
 * @param { guid:string } guid
 * @returns { Promise } Promises
 * 
 */
const getAssessmentData = (guid) => {
    try {
        const response = axios.get('/assessment/GetAssessmentsForRater/' + guid);
        return response;
    } catch (error) {
        console.log("while getting assessments in service:_", error);
    }
}

export {
    getAssessmentData
}